import app from "./app"

export const appReducers = {
  app: app.reducer
}
